<div *ngIf="!iconOnly && !isOutlined" class="avatar-{{size}}" [style.backgroundColor]="getAvatarBg()">
    <span *ngIf="!icon" class="initials-{{size}}">{{avatarTextVal}}</span>
    <span *ngIf="icon" class="qIcon-{{size}} {{iconSet}} {{icon}}"></span>
    <!-- <span *ngIf="icon" class="qIcon la {{icon}}"></span> -->
</div>

<div *ngIf="iconOnly" class="avatar">
    <span class="qIconBlack-{{size}} {{iconSet}} {{icon}}"></span>
    <!-- <span class="qIconBlack la {{icon}}"></span> -->
</div>

<div *ngIf="isOutlined" class="avatar-{{size}}" [style.borderColor]="getAvatarBg()" style="border-width: 1px; border-style: solid;">
    <span *ngIf="!icon" class="initials-{{size}}" [style.color]="getAvatarBg()">{{avatarTextVal}}</span>
    <span *ngIf="icon" class="qIcon-{{size}} {{iconSet}} {{icon}}"></span>
    <!-- <span *ngIf="icon" class="qIcon la {{icon}}"></span> -->
</div>
